var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCloudSlash = function SvgIconCloudSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.827 3.01a1 1 0 0 1 1.413.067l4.012 4.414q.03.03.057.062l10.93 12.024a1 1 0 0 1-1.479 1.346l-.85-.934A8.5 8.5 0 0 1 15 20.5H6.75a6.25 6.25 0 1 1 .267-12.494L3.76 4.423a1 1 0 0 1 .067-1.413M6.737 10a4.25 4.25 0 0 0 .013 8.5H15q.719 0 1.417-.155l-7.6-8.359a6.4 6.4 0 0 0-.317 2.011 1 1 0 1 1-2 .006A8.4 8.4 0 0 1 6.736 10M14.997 5.5a6.4 6.4 0 0 0-3.292.9 1 1 0 1 1-1.022-1.719 8.4 8.4 0 0 1 4.32-1.181 8.51 8.51 0 0 1 6.883 13.492 1 1 0 0 1-1.622-1.171A6.509 6.509 0 0 0 14.998 5.5"
  }))));
};
export default SvgIconCloudSlash;